import { matchIsValidTel } from 'mui-tel-input';

export const RTL_PHONE_LENGTH = 10;
export const RTL_PHONE_REGEX = new RegExp(`^\\d{9,${RTL_PHONE_LENGTH}}$`);

function matchIsValidRtlTel(phone: string) {
  const regex = RTL_PHONE_REGEX;
  return regex.test(phone);
}

function validateEmail(email: string) {
  const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  return regex.test(email);
}

export const validate = (
  t: (key: string) => string,
  values: { name: string; phone: string; email: string; consent?: boolean },
  rtl: boolean,
  consentRequired: boolean = false,
) => {
  const required = t('info.requiredField');

  const errors = {
    name: '',
    phone: '',
    email: '',
    consent: '',
  };

  if (!values.name) {
    errors.name = required;
  }

  if (!values.phone) {
    errors.phone = required;
  } else if (
    (rtl && !matchIsValidRtlTel(values.phone)) ||
    (!rtl && !matchIsValidTel(values.phone))
  ) {
    errors.phone = t('info.invalidPhone');
  }

  if (!values.email) {
    errors.email = required;
  } else if (!validateEmail(values.email)) {
    errors.email = t('info.invalidEmail');
  }

  if (consentRequired && !values.consent) {
    errors.consent = t('info.consentRequired');
  }

  return errors;
};
